import React, { createContext, useContext } from 'react';
import { useCurrentStage } from './useCurrentStage';
import { useStandings } from './useStandings';
import { useFixtures } from './useFixtures';
import { useStatistics } from './useStatistics';
import { useCountries } from './useCountries';

const SportsContext = createContext(null);

export const SportsProvider = ({ children }) => {
  const currentStage = useCurrentStage();
  const standings = useStandings();
  const fixtures = useFixtures();
  const statistics = useStatistics();
  const countries = useCountries();

  const value = {
    ...currentStage,
    ...standings,
    ...fixtures,
    ...statistics,
    ...countries,
  };

  return (
    <SportsContext.Provider value={value}>
      {children}
    </SportsContext.Provider>
  );
};

export const useSports = () => {
  const context = useContext(SportsContext);
  if (!context) {
    throw new Error('useSports must be used within a SportsProvider');
  }
  return context;
};

export default SportsContext;
